import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import SEO from '../components/seo'
import Layout from '../components/layout'
import Intro from '../components/intro'
import Post from '../components/post'
import PostGrid from '../components/post-grid'
import Navigation from '../components/navigation'
import { Link } from 'gatsby'

import * as style from '../styles/post-grid.module.css'

const Index = ({ data, pageContext: { nextPagePath, previousPagePath } }) => {
  const {
    allMarkdownRemark: { edges: posts },
  } = data

  return (
    <>
      <SEO />
      <Layout>
      <Intro />
      <div className={style.gridWrapper}>
        {posts.map(({ node }) => {
          const {
            id,
            frontmatter: {
              title,
              date,
              path,
              author,
              coverImage,
              tags,
            },
          } = node

          return (
              <PostGrid
                key={id}
                title={<Link to={path}>{title}</Link>}
                path={path}
                coverImage={coverImage}
                tags={tags} >
              </PostGrid>

          )
        })}
        </div>
      </Layout>
    </>
  )
}

Index.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.shape({
    nextPagePath: PropTypes.string,
    previousPagePath: PropTypes.string,
  }),
}

export const postsQuery = graphql`
  query($limit: Int!, $skip: Int!) {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "//posts//" } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            # date(formatString: "DD MMMM YYYY")
            path
            author
            excerpt
            tags
            coverImage {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Index
